<template>
  <div class="document">
    <div class="header">
      <es-header>
        <template #header>
          <div class="header-title">Cluster Group Summary</div>
        </template>
      </es-header>
    </div>
    <es-loader v-if="loading" style="margin: 6.5rem"/>
    <es-exception
      v-else-if="loadingError"
      exceptionMessage="There was an issue. Please try again or contact your administrator."
      margin="0"
      style="padding: 2rem; text-align:center"/>
    <div class="has-text-left group-summary-content" v-else>
      <div class="group-summary-info">
        Refer to the Elections Participation Summary (Step 2 for Elections)
        below to select the Base Year Decision
      </div>
      <es-exception
        v-if="!groups || !groups.length"
        exceptionMessage="No Cluster participation available."
        style="margin: 2rem; text-align:center"/>
      <div v-else class="group-summary-group" v-for="(group, index) in groups" :key="index">
        <div class="has-text-weight-bold">{{group.description}}</div>
        <div># of Sites <span class="has-text-weight-bold">{{group.siteCount}}</span></div>
        <div>
          Base Year
          <span
            class="has-text-weight-bold"
            :title="group.baseSchoolYear === '--' ?
              'Data does not exist' : group.graceYear === 'Y' ? 'Grace Year' : '' ">
            {{ group.baseSchoolYear }}
          </span>
        </div>
        <div>
          Base Year ISP%
          <span class="has-text-weight-bold">
            {{ group.baseYearISP }}
          </span>
        </div>
        <div class="border-right">
          Current Year ISP%
          <span class="has-text-weight-bold">
            {{ group.totalISP }}
          </span>
        </div>
        <div class="group-summary-base-decision">
          Base Year Decision Options:
          <template v-if="group.baseYearDecisions && group.baseYearDecisions.length">
            <cep-manager-decision-status
              v-for="(decision, index) in group.baseYearDecisions"
              :key="index"
              :status="decision"/>
          </template>
          <cep-manager-decision-status
            v-else
            :description="'Not Available. ISP% does not meet the requirement.'"
            :status="'E'"/>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import EsException from '@/components/EsException.vue';
import EsHeader from '@/components/EsHeader.vue';
import EsLoader from '@/components/EsLoader.vue';
import CepManagerDecisionStatus from '@/components/CepManagerDecisionStatus.vue';

export default {
  components: {
    EsException,
    EsHeader,
    EsLoader,
    CepManagerDecisionStatus,
  },
  props: {
    locationGroupId: {
      type: [String, Number],
    },
    schoolYear: {
      type: Number,
    },
  },
  data() {
    return {
      groups: [],
      loading: true,
      loadingError: null,
    };
  },
  created() {
    this.onLoad();
  },
  watch: {
    locationGroupId() {
      this.onLoad();
    },
  },
  methods: {
    async onLoad() {
      try {
        this.setBusy(true);
        this.loadingError = false;

        const response = await axios.get(`cep/${this.locationGroupId}/elections/${this.schoolYear}/clusters`);
        this.groups = response.data.data;
      } catch (e) {
        this.loadingError = true;
      } finally {
        this.setBusy(false);
      }
    },
    setBusy(loading) {
      this.loading = loading;
    },
  },
};
</script>

<style lang="sass" scoped>
  .group-summary-info
    padding: 0.25rem 0
  .group-summary-content
    padding: 1rem
    font-size: .85rem;
    color: #212529;
  .group-summary-group
    padding: 0.5rem 1rem
    margin: 0 -1rem
    &:not(:last-child)
      border-bottom: 1px solid #dee2e6
    > div
      padding-top: 0.25rem
      border-bottom: 1px solid #dee2e6;
      display: flex
      justify-content: space-between
      &:last-child,
        padding-top: 0.5rem
      &:last-child,
      &:first-child
        border-bottom: none
      &.group-summary-base-decision
        display: block
</style>
